__turbopack_context__.v({
  "root": "GradientTypography-module-scss-module__Hty3DW__root",
  "titleLine": "GradientTypography-module-scss-module__Hty3DW__titleLine",
  "titleMeasure": "GradientTypography-module-scss-module__Hty3DW__titleMeasure",
});
